import Highcharts from "highcharts";

const formatHighchartsNumber = (value: number): string => {
  if (value > 1000) {
    return `${(value / 1000).toFixed(1)}k`;
  } else {
    return Highcharts.numberFormat(value, -1, ".", ",");
  }
};

export default formatHighchartsNumber;
